export interface ContainRect { offX: number; offY: number; dispW: number; dispH: number }

/** Displayed-image rect when an image of natW×natH is shown with object-fit:contain
 *  inside a vpW×vpH box. Mirrors the letterbox math in smartZoom.computeZoom. */
export function containRect(vpW: number, vpH: number, natW: number, natH: number): ContainRect {
  if (!vpW || !vpH || !natW || !natH) return { offX: 0, offY: 0, dispW: 0, dispH: 0 };
  const imgAR = natW / natH;
  const vpAR = vpW / vpH;
  let dispW: number, dispH: number, offX: number, offY: number;
  if (imgAR > vpAR) { dispW = vpW; dispH = vpW / imgAR; offX = 0; offY = (vpH - dispH) / 2; }
  else { dispH = vpH; dispW = vpH * imgAR; offX = (vpW - dispW) / 2; offY = 0; }
  return { offX, offY, dispW, dispH };
}

/** box_2d [ymin,xmin,ymax,xmax] in 0-1000 -> percentages of the natural image box. */
export function boxToRectPercent(
  box: [number, number, number, number],
): { left: number; top: number; width: number; height: number } {
  const [ymin, xmin, ymax, xmax] = box;
  return { left: xmin / 10, top: ymin / 10, width: (xmax - xmin) / 10, height: (ymax - ymin) / 10 };
}
